import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { startCase, camelCase } from 'lodash';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

export const SetPageTitle = (router: Router, titleService: Title) => (): Subscription =>
  router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((path: any) => {
    const routePath = path.url.split('/');
    let route = routePath.pop().split('?')[0];

    if (/\d/.test(route)) {
      route = routePath[routePath.length - 1];
    }

    const title = ['login'].includes(route) ? '' : `${startCase(camelCase(route))} - `;

    titleService.setTitle(`${title}LM Admin`);
  });
